import { render, staticRenderFns } from "./BedTagsItemModal.vue?vue&type=template&id=5da70278&"
import script from "./BedTagsItemModal.vue?vue&type=script&lang=js&"
export * from "./BedTagsItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports